import { render } from "./EditPost.vue?vue&type=template&id=6da2971e&scoped=true"
import script from "./EditPost.vue?vue&type=script&lang=js"
export * from "./EditPost.vue?vue&type=script&lang=js"

import "./EditPost.vue?vue&type=style&index=0&id=6da2971e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da2971e"]])

export default __exports__